export interface AnalyticsPreferenceClient {
  opt_in_capturing(): void;
  opt_out_capturing(): void;
  reset(): void;
}

export function applyAnalyticsPreference(client: AnalyticsPreferenceClient, enabled: boolean): void {
  // Mirror the preference for isolated auth pages that intentionally load no SDK.
  if (typeof document !== 'undefined') {
    try { document.cookie = `rill_analytics_enabled=${enabled ? '1' : '0'}; Path=/; SameSite=Lax; Max-Age=31536000${typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : ''}`; } catch { /* Cookie access may be blocked. */ }
  }
  if (enabled) {
    client.opt_in_capturing();
    return;
  }
  client.reset();
  client.opt_out_capturing();
}
